import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Motorsport-Videoproduktion", to: "/motorsport-videoproduktion" },
  { label: "Eventfilm", to: "/eventfilm" },
  { label: "Videoproduktion Bochum", to: "/videoproduktion-bochum" },
  { label: "Videoproduktion Ruhrgebiet", to: "/videoproduktion-ruhrgebiet" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const SportContent = () => (
  <LandingPage
    path="/sport-content"
    metaTitle="Sport Content & Videoproduktion | Vereine, Athleten & Events"
    metaDescription="Cinematic Sport-Content für Vereine, Athleten, Sportevents & Sponsoren. Imagefilme, Highlight-Reels & Social-Content. Aus Bochum, deutschlandweit im Einsatz."
    eyebrow="Sport · Content · Vereine · Athleten"
    h1={
      <>
        Sport-Content, der <span className="text-gradient">Geschichten erzählt</span>.
      </>
    }
    intro="Wir produzieren Sport-Content für Vereine, Athletinnen, Athleten, Veranstalter & Sponsoren – emotional inszeniert, plattformgerecht ausgespielt und sponsorenwirksam erzählt."
    serviceName="Sport-Content & Videoproduktion"
    serviceDescription="Videoproduktion und Content für Sportvereine, Profi- und Amateurathleten, Verbände, Sportevents und Sponsoren."
    areaServed={["Bochum", "Ruhrgebiet", "Nordrhein-Westfalen", "Deutschland"]}
    bullets={[
      { title: "Athleten-Porträts", text: "Dokumentarische Stories, die Persönlichkeit, Disziplin und Werdegang zeigen – perfekt für Sponsorenakquise & Social Media." },
      { title: "Vereins- & Teamfilme", text: "Imagefilme, die Identität schaffen: für Mitgliedergewinnung, Förderer und Partner." },
      { title: "Sportevents & Highlights", text: "Live-Begleitung, Highlight-Reels und Aftermovies für Wettkämpfe, Turniere und Sportveranstaltungen." },
      { title: "Social-Content für Reichweite", text: "Kurze, plattformgerechte Cuts für Instagram, TikTok & YouTube Shorts – mit klarer Hook in den ersten 3 Sekunden." },
      { title: "Sponsoren-Storys", text: "Wir machen Sponsorenleistungen sichtbar – integriert, glaubwürdig und messbar." },
      { title: "Cinematic Look", text: "Kinoreife Bildsprache, präzise Audioarbeit und ein Schnitt, der Tempo & Emotion vereint." },
    ]}
    faqs={[
      { q: "Für welche Sportarten produziert ihr Content?", a: "Vom Mannschaftssport über Individualsport bis hin zu Motorsport – wir produzieren branchenübergreifend, solange das Storytelling im Mittelpunkt steht." },
      { q: "Begleitet ihr auch ganze Saisons?", a: "Ja. Wir bieten Saisonbegleitungen mit regelmäßigem Content-Output, planbaren Drehtagen und definierten Liefermengen." },
      { q: "Macht ihr auch Foto neben Video?", a: "Ja. Auf Wunsch liefern wir Bewegtbild & Fotograph parallel aus einer Hand." },
      { q: "Wie schnell bekommen wir Social-Cuts?", a: "Kurze Highlight-Clips erhaltet ihr typischerweise innerhalb von 24 bis 48 Stunden, längere Filme nach Vereinbarung." },
    ]}
    internalLinks={internal}
  />
);

export default SportContent;
